import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export type DepartedParticipant = {
  attendeeId: string
  name: string
  initials: string
  departedAt: number
}

export type DepartedParticipantsState = {
  departed: Map<string, DepartedParticipant>
  addDepartedParticipant: (participant: DepartedParticipant) => void
  isDeparted: (attendeeId: string) => boolean
  getDepartedParticipant: (attendeeId: string) => DepartedParticipant | undefined
  clearDeparted: () => void
}

export const useDepartedParticipantsStore = create<DepartedParticipantsState>()(
  devtools(
    (set, get) => ({
      departed: new Map(),

      addDepartedParticipant: (participant) =>
        set((state) => {
          const newDeparted = new Map(state.departed)
          newDeparted.set(participant.attendeeId, participant)
          return { departed: newDeparted }
        }),

      isDeparted: (attendeeId) => get().departed.has(attendeeId),

      getDepartedParticipant: (attendeeId) => get().departed.get(attendeeId),

      clearDeparted: () => set({ departed: new Map() })
    }),
    { name: 'DepartedParticipantsStore', enabled: import.meta.env.DEV }
  )
)
